import { render, staticRenderFns } from "./TATReportsTable.vue?vue&type=template&id=40555fc0"
import script from "./TATReportsTable.vue?vue&type=script&lang=js"
export * from "./TATReportsTable.vue?vue&type=script&lang=js"
import style0 from "./TATReportsTable.vue?vue&type=style&index=0&id=40555fc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports